import React from 'react';
import { Avatar, Select, Badge, Popover, Tag } from 'antd';
import { connect } from 'react-redux';
import * as actions from '../store/actions/agent';
import { UserOutlined } from '@ant-design/icons';


const { Option } = Select;


const AGENT_STATUS_LOGOUT = 1;
const AGENT_STATUS_AVAILABLE = 2;
// const AGENT_STATUS_ON_DEMAND = 3;
const AGENT_STATUS_ON_BREAK = 4;
// const AGENT_STATUS_UNKNOWN = 0;

const AGENT_STATUS_TEXT_MAPPING = {
  0: 'Unknown',
  1: 'Logged Out',
  2: 'Available',
  3: 'On Standby',
  4: 'On Break',
};

const COLOR_MAPPING_ICON = {
  0: '#40a9ff',
  1: '#ff4d4f',
  2: '#73d13d',
  3: '#87e8de',
  4: '#ffa940',
};

const COLOR_MAPPING = {
  0: 'geekblue',
  1: 'red',
  2: 'green',
  3: 'cyan',
  4: 'volcano',
};

function PopoverContent(username, password) {
  return <div>
    Please connect your SIP phone!<br />
    Username: <b>{username}</b> <br />
    Password: <b>{password}</b>
  </div>
}

class RegisteredButton extends React.Component {
  render() {
    return (
      <span>
        {
          this.props.is_registered
            ?
            <Badge status="success" text="Registered" />
            :
            <Popover content={PopoverContent(this.props.username, this.props.password)}>
              <Badge status="error" text="Not Registered" />
            </Popover>
        }
        &nbsp;&nbsp;
      </span>
    );
  }
}


class AgentStatus extends React.Component {

  tickAgentStatusLoad = () => {
    this.props.fetchAgentStatus();
  };

  componentDidMount() {
    this.props.fetchAgentStatus();
    this.timerID = setInterval(this.tickAgentStatusLoad, 15000);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  handleChange = (value) => {
    this.props.updateAgentStatus(value);
  }

  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  render() {
    return (
      <div className="div_welcome_user">
        <RegisteredButton is_registered={this.props.agent_registered} username={this.props.phone_login} password={this.props.phone_password} />

        <Tag color={COLOR_MAPPING[this.props.agent_status]}> {AGENT_STATUS_TEXT_MAPPING[this.props.agent_status]} </Tag>

        <Select placeholder="Set status" style={{ width: 120 }} onChange={this.handleChange}>
          {/* Not working with ant.design 4.0 */}
          {/* {this.props.agent_status !== AGENT_STATUS_AVAILABLE && this.props.agent_status !== AGENT_STATUS_ON_DEMAND &&
            < Option value={AGENT_STATUS_AVAILABLE}> Available</Option>
          }
          {this.props.agent_status !== AGENT_STATUS_ON_BREAK &&
            <Option value={AGENT_STATUS_ON_BREAK}>On Break</Option>
          }
          {this.props.agent_status !== AGENT_STATUS_LOGOUT &&
            <Option value={AGENT_STATUS_LOGOUT}>Log out</Option>
          } */}
          <Option value={AGENT_STATUS_AVAILABLE}> Available</Option>
          <Option value={AGENT_STATUS_ON_BREAK}>On Break</Option>
          <Option value={AGENT_STATUS_LOGOUT}>Log out</Option>
        </Select>
        &nbsp;&nbsp;
        <Avatar
          style={{ backgroundColor: COLOR_MAPPING_ICON[this.props.agent_status] }}
          icon={<UserOutlined />}
        /> {this.capitalizeFirstLetter(this.props.username)}
      </div >
    );
  }
}


const mapStateToProps = state => {
  return {
    agent_status: state.agent.agent_status,
    agent_registered: state.agent.agent_registered,
    phone_login: state.auth.phone_login,
    phone_password: state.auth.phone_password,
  }
}


const mapDispatchToProps = dispatch => {
  return {
    fetchAgentStatus: () => dispatch(actions.fetchAgentStatus()),
    updateAgentStatus: (status) => dispatch(actions.updateAgentStatus(status)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AgentStatus);

